import { render, staticRenderFns } from "./groupePublishStatus.vue?vue&type=template&id=586b26a8&scoped=true&"
import script from "./groupePublishStatus.vue?vue&type=script&lang=js&"
export * from "./groupePublishStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586b26a8",
  null
  
)

export default component.exports